/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ec33x5SEN4aEEFQbKCmZsX
// Component: gPXXnR2LihsE
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState,
  useTrigger
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: ec33x5SEN4aEEFQbKCmZsX/projectcss
import sty from "./PlasmicButtonPageOld.module.css"; // plasmic-import: gPXXnR2LihsE/css

createPlasmicElementProxy;

export const PlasmicButtonPageOld__VariantProps = new Array(
  "textColor",
  "isSelected"
);

export const PlasmicButtonPageOld__ArgProps = new Array(
  "onClick",
  "disabled",
  "name",
  "content"
);

const $$ = {};

function PlasmicButtonPageOld__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          disabled: false,
          content: "link button"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textColor",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.textColor
      },
      {
        path: "isSelected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isSelected
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const [isWrappAllHover, triggerWrappAllHoverProps] = useTrigger(
    "useHover",
    {}
  );
  const [isWrappAllFocus, triggerWrappAllFocusProps] = useTrigger(
    "useFocused",
    {}
  );
  const triggers = {
    hoverFocus_wrappAll: isWrappAllHover && isWrappAllFocus
  };
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"wrappAll"}
      data-plasmic-override={overrides.wrappAll}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_ec33x5SEN4aEEFQbKCmZsX",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.wrappAll,
        {
          [sty.wrappAllisSelected]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          ),
          [sty.wrappAlltextColor_brand]: hasVariant(
            $state,
            "textColor",
            "brand"
          ),
          [sty.wrappAlltextColor_primaryDark]: hasVariant(
            $state,
            "textColor",
            "primaryDark"
          ),
          [sty.wrappAlltextColor_secondary]: hasVariant(
            $state,
            "textColor",
            "secondary"
          ),
          [sty.wrappAlltextColor_tertiary]: hasVariant(
            $state,
            "textColor",
            "tertiary"
          )
        }
      )}
      data-plasmic-trigger-props={[
        triggerWrappAllHoverProps,
        triggerWrappAllFocusProps
      ]}
    >
      <div
        data-plasmic-name={"wrappContents"}
        data-plasmic-override={overrides.wrappContents}
        className={classNames("all", sty.wrappContents, {
          [sty.wrappContentsisSelected]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          )
        })}
      >
        <div
          className={classNames("all", "__wab_text", sty.text__krqEk, {
            [sty.textisSelected__krqEKoRsjf]: hasVariant(
              $state,
              "isSelected",
              "isSelected"
            ),
            [sty.texttextColor_brand__krqEkDtszW]: hasVariant(
              $state,
              "textColor",
              "brand"
            ),
            [sty.texttextColor_secondary__krqEkyeCuK]: hasVariant(
              $state,
              "textColor",
              "secondary"
            )
          })}
        >
          {"["}
        </div>
        <PlasmicLink__
          data-plasmic-name={"link"}
          data-plasmic-override={overrides.link}
          className={classNames(
            "all",
            "a",
            "a__ec33x",
            "__wab_text",
            sty.link,
            {
              [sty.linkisSelected]: hasVariant(
                $state,
                "isSelected",
                "isSelected"
              ),
              [sty.linktextColor_brand]: hasVariant(
                $state,
                "textColor",
                "brand"
              ),
              [sty.linktextColor_primaryDark]: hasVariant(
                $state,
                "textColor",
                "primaryDark"
              ),
              [sty.linktextColor_primaryGrey]: hasVariant(
                $state,
                "textColor",
                "primaryGrey"
              ),
              [sty.linktextColor_primaryLight]: hasVariant(
                $state,
                "textColor",
                "primaryLight"
              ),
              [sty.linktextColor_secondary]: hasVariant(
                $state,
                "textColor",
                "secondary"
              ),
              [sty.linktextColor_tertiary]: hasVariant(
                $state,
                "textColor",
                "tertiary"
              )
            }
          )}
          disabled={(() => {
            try {
              return $props.disabled;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          name={(() => {
            try {
              return $props.name;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
          onClick={async event => {
            const $steps = {};
            $steps["runOnClick"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["onClick"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnClick"] != null &&
              typeof $steps["runOnClick"] === "object" &&
              typeof $steps["runOnClick"].then === "function"
            ) {
              $steps["runOnClick"] = await $steps["runOnClick"];
            }
          }}
          platform={"react"}
        >
          <React.Fragment>
            {(() => {
              try {
                return $props.content;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "continue";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </PlasmicLink__>
        <div
          className={classNames("all", "__wab_text", sty.text__nwTp, {
            [sty.textisSelected__nwTpoRsjf]: hasVariant(
              $state,
              "isSelected",
              "isSelected"
            ),
            [sty.texttextColor_brand__nwTpDtszW]: hasVariant(
              $state,
              "textColor",
              "brand"
            ),
            [sty.texttextColor_secondary__nwTpYeCuK]: hasVariant(
              $state,
              "textColor",
              "secondary"
            )
          })}
        >
          {"]"}
        </div>
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox, {
          [sty.freeBoxisSelected]: hasVariant(
            $state,
            "isSelected",
            "isSelected"
          )
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  wrappAll: ["wrappAll", "wrappContents", "link", "freeBox"],
  wrappContents: ["wrappContents", "link"],
  link: ["link"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonPageOld__ArgProps,
          internalVariantPropNames: PlasmicButtonPageOld__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonPageOld__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "wrappAll") {
    func.displayName = "PlasmicButtonPageOld";
  } else {
    func.displayName = `PlasmicButtonPageOld.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonPageOld = Object.assign(
  // Top-level PlasmicButtonPageOld renders the root element
  makeNodeComponent("wrappAll"),
  {
    // Helper components rendering sub-elements
    wrappContents: makeNodeComponent("wrappContents"),
    link: makeNodeComponent("link"),
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicButtonPageOld
    internalVariantProps: PlasmicButtonPageOld__VariantProps,
    internalArgProps: PlasmicButtonPageOld__ArgProps
  }
);

export default PlasmicButtonPageOld;
/* prettier-ignore-end */
